export default __webpack_public_path__ + "static/media/shield.cb9c0e8c.png";